/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import Utils from "Utils/utils";
import { REPORT_DATE_FILTER_MIN_DATE } from "Static/constant";
import UpgradeIconTooltip from "Components/Paywall/UpgradeIconTooltip";
import userDetail from "Stores/userDetail";
import PaywallUtils from "Utils/PaywallUtils";

const DateRangePicker = props => {
  const {
    className = "",
    filterCbk = () => {},
    cancelCbk = () => {},
    customDate,
    inFreePlan = false,
    pageType = "",
    upgradePopupName = "",
    handleCustomDate = () => {},
    customDateObj = "",
    enableTimeRange = false
  } = props || {};

  const { planName = "" } = userDetail?.userFeatureFlag || {};

  const convertDateTo24TimeString = date => {
    if (!date) return "00:00:00";
    const dateObj = new Date(date);
    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const seconds = dateObj.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const getInitialStartTime = () => {
    if (customDateObj?.startDate) {
      return convertDateTo24TimeString(customDateObj.startDate);
    }
    return "00:00:00";
  };

  const getInitialEndTime = () => {
    if (customDateObj?.endDate) {
      return convertDateTo24TimeString(customDateObj.endDate);
    }
    return "23:59:59";
  };

  const [startTime, setStartTime] = useState(getInitialStartTime());
  const [endTime, setEndTime] = useState(getInitialEndTime());

  const prevStartDateRef = useRef(null);
  const prevEndDateRef = useRef(null);

  const getDatePartOnly = date => {
    if (!date) return null;
    const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  };

  const highlightErrMsg = (id, value) => {
    const errDom = document.getElementById(id);
    let toggleClass = errDom && errDom.classList;
    value
      ? toggleClass.add("highlightErr")
      : toggleClass.remove("highlightErr");
  };

  const handleChange = (item = {}) => {
    const { startDate = false, endDate = false } = item?.selection || {};

    // Preserve existing endDate if only startDate is being changed
    // Preserve existing startDate if only endDate is being changed
    const currentSelection = customDate?.[0] || {};
    const newSelection = {
      ...item.selection,
      startDate: startDate || currentSelection.startDate,
      endDate: endDate || currentSelection.endDate
    };

    let exceedRange =
      Utils.getDateDiffNumber(newSelection.startDate, newSelection.endDate) >
        91 || "";
    let applyBtn = document.getElementById("applyCustomDateFilter");
    highlightErrMsg("customDateFilterErrMsg", exceedRange);
    applyBtn &&
      newSelection.endDate &&
      newSelection.startDate &&
      (applyBtn.disabled = exceedRange || false);
    handleCustomDate([newSelection]);
  };

  const combineDateAndTime = (date, timeString) => {
    if (!date || !timeString) {
      return date;
    }
    const [hours24, minutes, seconds = 0] = timeString.split(":").map(Number);
    const newDate = new Date(date);
    newDate.setHours(hours24 || 0, minutes || 0, seconds || 0, 0);
    return newDate;
  };

  const formatTimeString = timeString => {
    if (!timeString) return "00:00:00";
    const parts = timeString.split(":");
    const hours = parts[0]?.padStart(2, "0") || "00";
    const minutes = parts[1]?.padStart(2, "0") || "00";
    const seconds = parts[2]?.padStart(2, "0") || "00";
    return `${hours}:${minutes}:${seconds}`;
  };

  const createApplyButton = () => {
    const dom = document.querySelector(`.dateRangePicker`);
    if (!dom) return;
    const existingButtonSection = dom.querySelector(".dateBtnSection");
    if (existingButtonSection) {
      existingButtonSection.remove();
    }

    const parentDom = document.createElement("div");
    parentDom.setAttribute("class", "dateBtnSection");
    const cancelBtn = document.createElement("input");
    cancelBtn.setAttribute("type", "button");
    cancelBtn.setAttribute("value", "Cancel");
    cancelBtn.setAttribute("class", "cancelCustomDateFilter");
    cancelBtn.setAttribute("id", "cancelCustomDateFilter");
    cancelBtn.addEventListener("click", e => {
      cancelCbk();
    });
    parentDom.appendChild(cancelBtn);
    const applyBtn = document.createElement("input");
    applyBtn.setAttribute("type", "button");
    applyBtn.setAttribute("value", "Apply");
    applyBtn.setAttribute("class", "applyCustomDateFilter");
    applyBtn.setAttribute("id", "applyCustomDateFilter");
    // Use current customDate state to check if dates are selected
    const currentSelection = customDate?.[0] || customDateObj || {};
    const { startDate = false, endDate = false } = currentSelection;
    (!startDate || !endDate) && applyBtn.setAttribute("disabled", true);
    applyBtn.addEventListener("click", e => {
      const startTimeInput = document.getElementById("startTimeInput");
      const endTimeInput = document.getElementById("endTimeInput");
      const isTimeRangeEnabled = !!(startTimeInput && endTimeInput);

      if (!inFreePlan) {
        // Use current customDate state instead of customDateObj prop to get latest selection
        const currentSelection = customDate?.[0] || customDateObj || {};
        const { startDate: currentStartDate, endDate: currentEndDate } =
          currentSelection;

        if (currentStartDate && currentEndDate) {
          if (isTimeRangeEnabled || enableTimeRange) {
            const startTime24Value = startTimeInput?.value || startTime;
            const endTime24Value = endTimeInput?.value || endTime;
            const startDateTime = combineDateAndTime(
              new Date(currentStartDate),
              startTime24Value
            );
            const endDateTime = combineDateAndTime(
              new Date(currentEndDate),
              endTime24Value
            );
            filterCbk({
              startDate: startDateTime,
              endDate: endDateTime,
              startTime: startTime24Value,
              endTime: endTime24Value
            });
          } else {
            filterCbk();
          }
        } else {
          filterCbk();
        }
      } else {
        PaywallUtils.upgradeUtilsFunction(
          upgradePopupName,
          true,
          planName,
          inFreePlan
        );
        cancelCbk();
      }
    });
    parentDom.appendChild(applyBtn);
    const errDom = document.createElement("div");
    errDom.setAttribute("id", "customDateFilterErrMsg");
    errDom.innerText = "*Date range limited to 90 days";
    parentDom.appendChild(errDom);
    if (inFreePlan) {
      var upgradeIcon = document.createElement("span");
      upgradeIcon.setAttribute("class", "wrapUpgradeIconTooltip");
      upgradeIcon.setAttribute("id", "wrapUpgradeIconTooltip");
      ReactDOM.render(
        <UpgradeIconTooltip type={upgradePopupName} enableTooltip={false} />,
        upgradeIcon
      );
      parentDom.appendChild(upgradeIcon);
    }
    dom.appendChild(parentDom);
  };

  const createTimePicker = () => {
    if (!enableTimeRange) {
      const dom = document.querySelector(`.${className || "dateRangePicker"}`);
      if (dom) {
        const existingTimePicker = dom.querySelector(".timeRangeWrapper");
        if (existingTimePicker) {
          existingTimePicker.remove();
        }
      }
      return;
    }

    const dom = document.querySelector(`.${className || "dateRangePicker"}`);
    if (!dom) return;
    const existingTimePicker = dom.querySelector(".timeRangeWrapper");
    if (existingTimePicker) {
      existingTimePicker.remove();
    }

    if (!document.getElementById("hideTimePickerIcon")) {
      const style = document.createElement("style");
      style.id = "hideTimePickerIcon";
      style.textContent = `
        input[type="time"]::-webkit-calendar-picker-indicator {
          display: none !important;
          -webkit-appearance: none !important;
          appearance: none !important;
          opacity: 0 !important;
          width: 0 !important;
          height: 0 !important;
          pointer-events: none !important;
        }
        input[type="time"]::-webkit-inner-spin-button,
        input[type="time"]::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
          appearance: none !important;
          margin: 0 !important;
        }
        input[type="time"] {
          -webkit-appearance: none !important;
          -moz-appearance: textfield !important;
          appearance: none !important;
        }
        #startTimeInput::-webkit-calendar-picker-indicator,
        #endTimeInput::-webkit-calendar-picker-indicator {
          display: none !important;
          -webkit-appearance: none !important;
          appearance: none !important;
          opacity: 0 !important;
          width: 0 !important;
          height: 0 !important;
          pointer-events: none !important;
        }
        /* Force 24-hour format and hide AM/PM indicators */
        input[type="time"]::-webkit-datetime-edit-ampm-field {
          display: none !important;
        }
        input[type="time"]::-webkit-datetime-edit-hour-field,
        input[type="time"]::-webkit-datetime-edit-minute-field,
        input[type="time"]::-webkit-datetime-edit-second-field {
          padding: 0;
        }
        #startTimeInput::-webkit-datetime-edit-ampm-field,
        #endTimeInput::-webkit-datetime-edit-ampm-field {
          display: none !important;
        }
        /* Additional Firefox support */
        input[type="time"] {
          text-align: center;
        }
      `;
      document.head.appendChild(style);
    }

    const dateDisplayWrapper = dom.querySelector(".rdrDateDisplayWrapper");

    const timeWrapper = document.createElement("div");
    timeWrapper.setAttribute("class", "timeRangeWrapper");
    timeWrapper.style.cssText = `
      padding: 5px 11px;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      gap: 15px;
      align-items: center;
      background: transparent;
    `;

    const startTimeContainer = document.createElement("div");
    startTimeContainer.setAttribute("class", "startTimeContainer");
    startTimeContainer.style.cssText =
      "display: flex; align-items: center; justify-content: center; gap: 8px; flex: 1; width: 100px; border: 1px solid #ddd; border-radius: 4px; background: white;";

    const startTimeInput = document.createElement("input");
    startTimeInput.setAttribute("type", "time");
    startTimeInput.setAttribute("id", "startTimeInput");
    startTimeInput.setAttribute("step", "1");
    startTimeInput.setAttribute("lang", "en-GB"); // Force 24-hour format
    startTimeInput.value = formatTimeString(startTime);
    startTimeInput.style.cssText = `
      padding: 6px 0;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      flex: 0 0 auto;
      text-align: center;
      width: 80px;
      height: 2rem;
      font-family: Graphik-Regular;
    `;

    startTimeInput.addEventListener("input", e => {
      const time24Value = e.target.value;
      if (time24Value) {
        setStartTime(formatTimeString(time24Value));
      }
    });

    startTimeContainer.appendChild(startTimeInput);
    timeWrapper.appendChild(startTimeContainer);

    const endTimeContainer = document.createElement("div");
    endTimeContainer.setAttribute("class", "endTimeContainer");
    endTimeContainer.style.cssText =
      "display: flex; align-items: center; justify-content: center; gap: 8px; flex: 1; width: 100px; border: 1px solid #ddd; border-radius: 4px; background: white;";

    const endTimeInput = document.createElement("input");
    endTimeInput.setAttribute("type", "time");
    endTimeInput.setAttribute("id", "endTimeInput");
    endTimeInput.setAttribute("step", "1");
    endTimeInput.setAttribute("lang", "en-GB"); // Force 24-hour format
    endTimeInput.value = formatTimeString(endTime);
    endTimeInput.style.cssText = `
      padding: 6px 0;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      flex: 0 0 auto;
      text-align: center;
      width: 80px;
      height: 2rem; 
      font-family: Graphik-Regular;
    `;

    endTimeInput.addEventListener("input", e => {
      const time24Value = e.target.value;
      if (time24Value) {
        setEndTime(formatTimeString(time24Value));
      }
    });

    endTimeContainer.appendChild(endTimeInput);
    timeWrapper.appendChild(endTimeContainer);

    if (dateDisplayWrapper) {
      if (dateDisplayWrapper.firstChild) {
        dateDisplayWrapper.insertBefore(
          timeWrapper,
          dateDisplayWrapper.firstChild.nextSibling
        );
      } else {
        dateDisplayWrapper.appendChild(timeWrapper);
      }
    } else {
      const calendarWrapper = dom.querySelector(".rdrCalendarWrapper") || dom;
      calendarWrapper.insertBefore(timeWrapper, calendarWrapper.firstChild);
    }
  };

  const updateTimeInputs = () => {
    if (!enableTimeRange) return;
    const startTimeInputEl = document.getElementById("startTimeInput");
    if (startTimeInputEl) {
      startTimeInputEl.setAttribute("lang", "en-GB"); // Force 24-hour format
      startTimeInputEl.value = formatTimeString(startTime);
    }
    const endTimeInputEl = document.getElementById("endTimeInput");
    if (endTimeInputEl) {
      endTimeInputEl.setAttribute("lang", "en-GB"); // Force 24-hour format
      endTimeInputEl.value = formatTimeString(endTime);
    }
  };

  useEffect(() => {
    createApplyButton();
    const timer = setTimeout(() => {
      createTimePicker();
      updateTimeInputs();
    }, 100);
    return () => clearTimeout(timer);
  }, [enableTimeRange, customDateObj]);

  useEffect(() => {
    if (enableTimeRange && customDateObj) {
      if (customDateObj.startDate) {
        const currentDatePart = getDatePartOnly(customDateObj.startDate);
        const prevDatePart = prevStartDateRef.current;
        const dateChanged =
          prevDatePart !== null && currentDatePart !== prevDatePart;
        const isInitializing = prevDatePart === null;

        const time = convertDateTo24TimeString(customDateObj.startDate);

        if (time !== "00:00:00") {
          setStartTime(time);
          prevStartDateRef.current = currentDatePart;
        } else if (
          isInitializing ||
          (dateChanged && startTime === "00:00:00")
        ) {
          setStartTime(time);
          prevStartDateRef.current = currentDatePart;
        } else if (dateChanged) {
          prevStartDateRef.current = currentDatePart;
        }
      } else {
        prevStartDateRef.current = null;
      }

      if (customDateObj.endDate) {
        const currentDatePart = getDatePartOnly(customDateObj.endDate);
        const prevDatePart = prevEndDateRef.current;
        const dateChanged =
          prevDatePart !== null && currentDatePart !== prevDatePart;
        const isInitializing = prevDatePart === null;

        const time = convertDateTo24TimeString(customDateObj.endDate);
        const isDefaultTime = time === "23:59:59" || time === "00:00:00";
        const isCurrentDefault =
          endTime === "23:59:59" || endTime === "00:00:00";

        if (!isDefaultTime) {
          setEndTime(time);
          prevEndDateRef.current = currentDatePart;
        } else if (isInitializing || (dateChanged && isCurrentDefault)) {
          setEndTime(time === "00:00:00" ? "23:59:59" : time);
          prevEndDateRef.current = currentDatePart;
        } else if (dateChanged) {
          prevEndDateRef.current = currentDatePart;
        }
      } else {
        prevEndDateRef.current = null;
      }
    }
  }, [customDateObj?.startDate, customDateObj?.endDate, enableTimeRange]);

  useEffect(() => {
    if (enableTimeRange) {
      updateTimeInputs();
    }
  }, [startTime, endTime, enableTimeRange]);

  useEffect(() => {
    const timer = setTimeout(() => {
      createTimePicker();
    }, 100);
    return () => clearTimeout(timer);
  }, [customDate, enableTimeRange]);

  return (
    <DateRange
      className={className}
      editableDateInputs={false}
      onChange={handleChange}
      moveRangeOnFirstSelection={false}
      ranges={customDate}
      minDate={new Date(REPORT_DATE_FILTER_MIN_DATE)}
      maxDate={new Date()}
    />
  );
};

export default DateRangePicker;
export { DateRangePicker };
